var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('b-modal',{attrs:{"id":_vm.LOADING_MODAL_ID,"hide-header-close":"","no-close-on-backdrop":"","hide-footer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }